import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getTreatmentAcceptanceOverview,
  type TreatmentAcceptanceOverviewResult,
} from '@services/api/dashboard/treatment-acceptance-overview.api'

export function useTreatmentAcceptanceOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<TreatmentAcceptanceOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getTreatmentAcceptanceOverview, {
    enabled,
    queued,
  })
}
